import { render, staticRenderFns } from "./SecondPage.vue?vue&type=template&id=93de8f36&scoped=true"
import script from "./SecondPage.vue?vue&type=script&lang=js"
export * from "./SecondPage.vue?vue&type=script&lang=js"
import style0 from "./SecondPage.vue?vue&type=style&index=0&id=93de8f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93de8f36",
  null
  
)

export default component.exports